<template>
    <div class="app_container">
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">

                <el-form-item>
                    <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="loadData"  :inline="true"></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>


            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/inspectionAdd' ,query: { callback:request }}">
                    <el-button type="primary" v-w-role="'ITSM-0235'">创建</el-button>
                </router-link>
            </div>
            <el-table :data="tableData" v-loading="!loading" >
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column type="selection" width="55"></el-table-column>-->
                <!--<el-table-column label="编号" prop="serialNumber"></el-table-column>-->
                <el-table-column label="标题" prop="title"></el-table-column>
                <el-table-column label="巡检对象" prop="cmdb"  width="120px">
                    <template slot-scope="scope">
                        <el-button v-for="item in scope.row.cmdb" type="text" style="color: black">{{item.title}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="处理组" prop="handlerGroup"></el-table-column>
                <el-table-column label="处理人" prop="currentHandler"></el-table-column>

                <el-table-column label="下一次运行时间" prop="runningTime" width="140">
                    <!--<template slot-scope="scope">-->
                        <!--{{ scope.row.status | tableVal(changeStatus) }}-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column label="运行状态" prop="status">
                    <template slot-scope="scope">
                        <el-button type="text">{{scope.row.status==true?'启用':'禁用'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="巡检周期">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.timeType=='once'">{{'生成一次'}}</el-button>
                        <el-button type="text" v-if="scope.row.timeType=='daily'">{{'每日计划'}}</el-button>
                        <el-button type="text" v-if="scope.row.timeType=='weekly'">{{'每周计划'}}</el-button>
                        <el-button type="text" v-if="scope.row.timeType=='monthly'">{{'每月计划'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
                <el-table-column label="创建人" prop="createUser" ></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">

                        <el-button type="text" @click="operatorBtn(scope.row)">{{!scope.row.status?'启动':'停止'}}</el-button>
                        <router-link :to="{ path:'/inspectionAdd' ,query: { callback:request,type:'edit',id:scope.row.id}}">
                            <el-button type="text" :disabled="scope.row.status">编辑</el-button>
                        </router-link>

                        <el-button class="table-del-btn" type="text" @click="deleteRole(scope.row)" v-w-role="'ITSM-0236'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    import services from "./inspection.service"
    export default {
        data() {
            return {
                form:{
                    // changeStatus:'',
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                id:null,
                loading:true,

                ExportBtn:false,
            }
        },
        created() {

            this.request();
        },
        computed:{
            // dictionary(){
            //     return this.$store.state.dictionary;
            // },
            // changeStatus(){
            //     return this.dictionary.change_status;
            // }
        },
        methods: {
            loadData(){
                this.form.pageIndex = 1;
                this.request();
            },
            request(){
                // // 获取列表数据
                // console.log(this.dictionary,'字典');
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                // console.log(this.form,'这是changeManage里的request请求前，打印this.form');
                services.getInspectionList(this.form).then(res => {
                    // console.log(res,'这是changeManage里的request请求后，打印res');
                    this.tableData = res.list;
                    // this.id=this.tableData.id
                    // console.log(this.tableData);
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = true;
                })
            },
            operatorBtn(row){
                this.openMessage(`您确定要${!row.status?'启动':'停止'}吗`,'确定',() =>{
                    services.operatorInspection({id:row.id,status:!row.status}).then(res =>{
                        this.$message.success(`${!row.status?'启动':'停止'}成功`)
                        this.request()
                    }).catch(err =>{
                        this.$message.error(err.message)
                    })
                })
            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deleteInspection({ id:row.id }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style scoped>

</style>
